/* Text Entry Styling */

.input {
    width: 100%;
}

.fieldDescription {
    composes: fieldDescription from './common.module.css';
}